import TEPopupForm from './TEPopupForm'

export default TEPopupForm
